// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { NetBlockWithRelationsSchema } from './NetBlockRelationsSchema'
import type { NetBlockWithRelations } from './NetBlockRelationsSchema'
import { HostGeoSchema } from './HostGeoSchema'
import type { HostGeo } from './HostGeoSchema'
import { NetworkServiceWithRelationsSchema } from './NetworkServiceRelationsSchema'
import type { NetworkServiceWithRelations } from './NetworkServiceRelationsSchema'
import { SoftwareWithRelationsSchema } from './SoftwareRelationsSchema'
import type { SoftwareWithRelations } from './SoftwareRelationsSchema'
import { VhostBindingWithRelationsSchema } from './VhostBindingRelationsSchema'
import type { VhostBindingWithRelations } from './VhostBindingRelationsSchema'
import { HostSchema } from './HostSchema';

/////////////////////////////////////////
// HOST RELATION SCHEMA
/////////////////////////////////////////

export type HostRelations = {
  surface: ExternalNetworkWithRelations;
  netblock: NetBlockWithRelations;
  geo?: HostGeo | null;
  services: NetworkServiceWithRelations[];
  software: SoftwareWithRelations[];
  vhostBindings: VhostBindingWithRelations[];
};

export type HostWithRelations = z.infer<typeof HostSchema> & HostRelations

export const HostWithRelationsSchema: z.ZodType<HostWithRelations> = HostSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  netblock: z.lazy(() => NetBlockWithRelationsSchema),
  geo: z.lazy(() => HostGeoSchema).nullable(),
  services: z.lazy(() => NetworkServiceWithRelationsSchema).array(),
  software: z.lazy(() => SoftwareWithRelationsSchema).array(),
  vhostBindings: z.lazy(() => VhostBindingWithRelationsSchema).array(),
}))